/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { Icon } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery, useModal } from '@panel/commons/hooks';
import { isMobileDevice, site } from '@panel/commons/helpers';
import { SavePostingSelectors } from '../../ducks/savePosting';
import { sendEvent } from '../../utils/trackingEvent';
import { Modal } from '../Modals/ModalWrapper';
import { SaveChangeForm } from '../Modals/saveChangeForm';
import { LeavePaymentForm } from '../Modals/leavePaymentForm';
import { useStepperCtx } from '../stepper/steppercontex';
import { getPaymentLoadingStatus } from '../../ducks/step4Module2';
import { Step1Module1Selectors } from '../../ducks/step1Module1';
import { isPaymentScreen, getPaymentSuccessTo } from '../../utils/path';
import {
  BackButton,
  ButtonsRow,
  Loading,
  LoadingContainer,
  StyledLink,
  Submit,
  Title,
  Wrapper,
  WrapperContent
} from './styles';
import { getMultimediaState } from '../../ducks/step2';

const WrapperContainer = ModuleComponent => ({
  back = '',
  step,
  title = '',
  eventName = '',
  saveExit = true,
  ...rest
}) => {
  const [id, setId] = useState('');
  const [hideSubmit, setHideSubmit] = useState(false);
  const { postingId, loading, saveAndExit, savedFromModal } = useSelector(SavePostingSelectors.getSavePostingState);
  const { operationTypeId, propertyTypeId, subPropertyTypeId, propertyTypes, propertySubTypes } = useSelector(
    Step1Module1Selectors.getInfoEvents
  );
  const paymentLoading = useSelector(getPaymentLoadingStatus);
  const { processing: uploadInProgress } = useSelector(getMultimediaState);
  const [postingIdURL] = useQuery(useLocation(), ['postingId']) || postingId;
  const { pathname } = useLocation();
  const { isShowing, toggleValue } = useModal();
  const { preventTransition, setPreventTransition, stepperFormRef } = useStepperCtx();
  const { t } = useTranslation();
  const { push } = useHistory();
  const isMobile = isMobileDevice();
  const isPaymentError = /pago\/error/.test(pathname);
  const isPaymentSuccess = /pago\/exito/.test(pathname);
  const isPaymentPaypal = /pago$/.test(pathname) && site.isPanama;
  const isWireTransfer = /transferencia$/.test(pathname) && site.isPanama;
  const isLoading = paymentLoading || loading || uploadInProgress;

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);

  const handleOpenModal = () => {
    toggleValue(true);
  };

  const handleBack = () => {
    if (isLoading) return;
    if (eventName) {
      const propertyObj = { list: propertyTypes, id: propertyTypeId };
      const subPropertyObj = { list: propertySubTypes, id: subPropertyTypeId };
      sendEvent(eventName, 'Atras', operationTypeId, propertyObj, subPropertyObj);
    }
    if (!preventTransition) {
      if (step) {
        push(`/publicador/${step}/${back}${postingIdURL ? `?postingId=${postingIdURL}` : ''}`);
      } else if (back) {
        push(`/publicador/${back}${postingIdURL ? `?postingId=${postingIdURL}` : ''}`);
      }
    } else {
      handleOpenModal();
    }
  };

  const handleModalClose = () => {
    toggleValue(false);
  };

  const handleRedirect = () => {
    if (step) {
      push(`/publicador/${step}/${back}${postingIdURL ? `?postingId=${postingIdURL}` : ''}`);
    } else if (back) {
      push(`/publicador/${back}${postingIdURL ? `?postingId=${postingIdURL}` : ''}`);
    }
  };

  const handleModalRedirect = () => {
    handleModalClose();
    setPreventTransition(null);
    handleRedirect();
  };

  const getSubmitButtonValue = () => {
    if (isPaymentError) {
      return 'Ir a seleccion de planes';
    }
    if (id === 'step4Module2Form') {
      return t('publisher.btn.payment');
    }
    if (id === 'step4Module2FormContact') {
      return t('publisher.btn.send');
    }
    if (id === 'step4module2PayPalForm') {
      return t('publisher.btn.buy');
    }
    if (id !== 'step4Module3Form') {
      return t('publisher.btn.continue');
    }
    return t('panel.header.btn.publish');
  };

  return (
    <Wrapper moduleId={id} data-repa={`moduleWrapper-${id}`}>
      {isShowing && !isPaymentScreen(pathname) && (
        <Modal>
          <SaveChangeForm
            data-repa={`moduleWrapper-${id}-modal`}
            openModal={isShowing}
            onClose={handleModalClose}
            handleRedirect={handleModalRedirect}
            formRef={stepperFormRef}
            goBack={step ? `/publicador/${step}/${back}` : `/publicador/${back}`}
          />
        </Modal>
      )}
      {isShowing && isPaymentScreen(pathname) && (
        <Modal>
          <LeavePaymentForm openModal={isShowing} onClose={handleModalClose} handleRedirect={handleModalRedirect} />
        </Modal>
      )}
      <Title moduleId={id} data-repa={`moduleWrapper-${id}-title`}>
        {title}
      </Title>
      <WrapperContent>
        <ModuleComponent setHideSubmit={setHideSubmit} loading={isLoading} setId={setId} {...rest} />
        <ButtonsRow
          data-repa={`moduleWrapper-${id}-buttons-row`}
          className={classnames({ only: saveExit === false, step1: !back })}
          saveExit={saveExit}
          isPaymentError={isPaymentError}
          isPaymentSuccess={isPaymentSuccess}
        >
          {isPaymentError && (
            <StyledLink
              data-repa={`moduleWrapper-${id}-button-backToPlanSelection`}
              to={{
                pathname: '/publicador/planes/seleccion',
                search: `?postingId=${postingIdURL}`
              }}
            >
              {t('publisher.step4.module2.button.backToPlans')}
            </StyledLink>
          )}
          {isPaymentSuccess && (
            <StyledLink
              data-repa={`moduleWrapper-${id}-button-ContinueToPublication`}
              to={getPaymentSuccessTo(postingIdURL)}
            >
              {t('publisher.step4.module2.button.continueToPublication')}
            </StyledLink>
          )}
          {!isMobile && back && !isPaymentError && !isPaymentSuccess && (
            <BackButton data-repa={`moduleWrapper-${id}-button-back`} onClick={handleBack} disabled={loading}>
              <Icon name='chevronLeft' width={28} height={28} colorFill='black' />
              {t('publisher.btn.back')}
            </BackButton>
          )}
          <div className='submitContainer'>
            {saveExit &&
              (isLoading && saveAndExit && !savedFromModal ? (
                <LoadingContainer className='saveAndExit'>
                  <Loading className='dot-flashing' saveAndExit />
                </LoadingContainer>
              ) : (
                <Submit
                  data-repa={`moduleWrapper-${id}-button-saveAndExit`}
                  disabled={isLoading}
                  id='saveAndExit'
                  className='saveAndExit'
                  form={id}
                  type='submit'
                  value={t('publisher.btn.save')}
                />
              ))}
            {isLoading && !saveAndExit && !savedFromModal && !isPaymentPaypal ? (
              <LoadingContainer>
                <Loading className='dot-flashing' />
              </LoadingContainer>
            ) : (
              !isPaymentError &&
              !isPaymentSuccess &&
              !isPaymentPaypal && (
                <Submit
                  data-repa={`moduleWrapper-${id}-button-submit`}
                  disabled={isLoading}
                  className='dot-flashing'
                  hide={hideSubmit}
                  onClick={() => isWireTransfer && push('/')}
                  form={!isWireTransfer && id}
                  type='submit'
                  value={getSubmitButtonValue()}
                />
              )
            )}
          </div>
        </ButtonsRow>
      </WrapperContent>
    </Wrapper>
  );
};

export { WrapperContainer };
